import React, { useEffect, useRef, useState } from 'react'
import { Img, Button, Text, SelectBox, Heading, Header1 } from 'components'

export default function Webp101OnePage() {
  return (
    <div>
      <div className="relative w-[100vw] h-full mx-auto">
        <div className="absolute top-0 left-0 w-full h-full z-[-1] animate-fade-in ">
          <video autoPlay loop muted className="w-full h-full object-cover">
            <source src="/video/bg.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="scrollable-content w-full bg-transparent relative animate-fade-in overflow-y-auto">
          <div className="w-full min-h-screen bg-transparent relative animate-fade-in overflow-hidden">
            <div className="flex flex-col items-start p-[42px] md:p-5 h-full">
              <header className="flex self-stretch justify-between items-center ml-8">
                <div className="flex sm:flex-col justify-between items-start w-[48%] gap-5">
                  <div className="flex justify-between items-start w-[50%] sm:w-full gap-5">
                    <div className="flex justify-center items-center w-[300px]">
                      <Img
                        src="images/img_vector.svg"
                        alt="vector_one"
                        className="h-[53px]"
                      />
                      <div className="flex justify-center ml-3 flex-1">
                        <div className="flex flex-col items-start gap-[5px]">
                          <div className="flex">
                            <Img
                              src="images/img_vector_gray_100.svg"
                              alt="vector_three"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/img_vector_gray_100_13x9.svg"
                              alt="vector_five"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/E.svg"
                              alt="vector_seven"
                              className="h-[13px]"
                            />
                          </div>
                          <div className="flex">
                            <Img
                              src="images/img_vector_13x9.svg"
                              alt="vector_nine"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/img_vector_1.svg"
                              alt="vector_eleven"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/img_vector_2.svg"
                              alt="vector_thirteen"
                              className="h-[13px] ml-0.5"
                            />
                            <Img
                              src="images/img_vector_3.svg"
                              alt="vector_fifteen"
                              className="h-[13px] ml-0.5"
                            />
                            <Img
                              src="images/img_vector_4.svg"
                              alt="vector"
                              className="h-[13px] ml-0.5"
                            />
                            <Img
                              src="images/img_vector_gray_100.svg"
                              alt="vector_nineteen"
                              className="h-[13px] ml-[5px]"
                            />
                            <Img
                              src="images/img_vector_gray_100_13x11.svg"
                              alt="vector"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/img_vector_5.svg"
                              alt="vector"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/img_vector_gray_100_13x8.svg"
                              alt="vector"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/E.svg"
                              alt="vector"
                              className="h-[13px]"
                            />
                          </div>
                          <div className="flex">
                            <Img
                              src="images/img_vector_4.svg"
                              alt="vector"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/img_vector_gray_100_13x11.svg"
                              alt="vector"
                              className="h-[13px]"
                            />
                            <Img
                              src="images/img_vector_1.svg"
                              alt="vector"
                              className="h-[13px]"
                            />
                          </div>
                        </div>
                        <div className="h-[53px] w-[8px] ml-[47px] bg-deep_purple-A200 ml-[48px]" />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between w-[550px]">
                    <a href="#" className="mt-2.5">
                      <Text size="xs" as="p">
                        Home
                      </Text>
                    </a>
                    <a
                      href="https://roundtable-dao.gitbook.io/roundtable-dao/"
                      className="mt-2.5"
                    >
                      <Text size="xs" as="p">
                        Docs
                      </Text>
                    </a>
                    <a href="airdrop" className="mt-2.5">
                      <Text size="xs" as="p">
                        Airdrop
                      </Text>
                    </a>
                  </div>
                </div>
                <div className="flex sm:flex-col justify-between items-center w-[450px] gap-5">
                  <div className="flex justify-center w-[44%] sm:w-full">
                    <div className="flex justify-around items-center w-[300px] ml-[-30px]">
                      <Img
                        src="images/union.svg"
                        alt="union_one"
                        style={{
                          width: '32px',
                          height: '32px',
                          transform: 'rotate(30deg)',
                          flexShrink: 0,
                        }}
                        className="z-[1] object-cover"
                      />
                      <a href="#" className="ml-[-9px]">
                        <Text size="xs" as="p">
                          Merlin Chain
                        </Text>
                      </a>
                    </div>
                  </div>
                  <div
                    className="flex justify-center ml-[-30px]"
                    onClick={() => alert('comming soon！')}
                  >
                    <svg
                      width="277"
                      height="108"
                      viewBox="0 0 277 108"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_0_1)">
                        <path
                          d="M22.5 48C22.5 30.603 36.603 16.5 54 16.5H223C240.397 16.5 254.5 30.603 254.5 48C254.5 65.397 240.397 79.5 223 79.5H54C36.603 79.5 22.5 65.397 22.5 48Z"
                          stroke="url(#paint0_linear_0_1)"
                          shape-rendering="crispEdges"
                        />
                      </g>
                      <path
                        d="M76.7813 54.165C75.9913 54.165 75.2563 54.03 74.5763 53.76C73.9063 53.48 73.3163 53.09 72.8063 52.59C72.3063 52.09 71.9163 51.51 71.6363 50.85C71.3563 50.18 71.2163 49.46 71.2163 48.69C71.2163 47.92 71.3563 47.205 71.6363 46.545C71.9163 45.875 72.3063 45.295 72.8063 44.805C73.3063 44.315 73.8913 43.935 74.5613 43.665C75.2413 43.385 75.9763 43.245 76.7663 43.245C77.6063 43.245 78.3513 43.38 79.0013 43.65C79.6613 43.92 80.2363 44.29 80.7263 44.76L79.1513 46.35C78.8713 46.05 78.5313 45.815 78.1313 45.645C77.7413 45.475 77.2863 45.39 76.7663 45.39C76.3063 45.39 75.8813 45.47 75.4913 45.63C75.1113 45.78 74.7813 46 74.5013 46.29C74.2313 46.58 74.0163 46.93 73.8563 47.34C73.7063 47.75 73.6313 48.2 73.6313 48.69C73.6313 49.19 73.7063 49.645 73.8563 50.055C74.0163 50.465 74.2313 50.815 74.5013 51.105C74.7813 51.395 75.1113 51.62 75.4913 51.78C75.8813 51.94 76.3063 52.02 76.7663 52.02C77.3063 52.02 77.7763 51.935 78.1763 51.765C78.5763 51.595 78.9213 51.36 79.2113 51.06L80.8013 52.65C80.2913 53.12 79.7063 53.49 79.0463 53.76C78.3963 54.03 77.6413 54.165 76.7813 54.165ZM86.7283 54.18C85.9283 54.18 85.1883 54.04 84.5083 53.76C83.8383 53.48 83.2483 53.09 82.7383 52.59C82.2283 52.09 81.8333 51.51 81.5533 50.85C81.2733 50.18 81.1333 49.46 81.1333 48.69C81.1333 47.91 81.2733 47.19 81.5533 46.53C81.8333 45.87 82.2233 45.295 82.7233 44.805C83.2233 44.305 83.8083 43.92 84.4783 43.65C85.1583 43.37 85.8983 43.23 86.6983 43.23C87.4883 43.23 88.2183 43.37 88.8883 43.65C89.5683 43.92 90.1583 44.305 90.6583 44.805C91.1683 45.295 91.5633 45.875 91.8433 46.545C92.1233 47.205 92.2633 47.925 92.2633 48.705C92.2633 49.475 92.1233 50.195 91.8433 50.865C91.5633 51.525 91.1733 52.105 90.6733 52.605C90.1733 53.095 89.5833 53.48 88.9033 53.76C88.2333 54.04 87.5083 54.18 86.7283 54.18ZM86.6983 52.035C87.3283 52.035 87.8783 51.895 88.3483 51.615C88.8283 51.335 89.1983 50.945 89.4583 50.445C89.7183 49.935 89.8483 49.35 89.8483 48.69C89.8483 48.19 89.7733 47.74 89.6233 47.34C89.4733 46.93 89.2583 46.58 88.9783 46.29C88.6983 45.99 88.3633 45.765 87.9733 45.615C87.5933 45.455 87.1683 45.375 86.6983 45.375C86.0683 45.375 85.5133 45.515 85.0333 45.795C84.5633 46.065 84.1983 46.45 83.9383 46.95C83.6783 47.44 83.5483 48.02 83.5483 48.69C83.5483 49.19 83.6233 49.645 83.7733 50.055C83.9233 50.465 84.1333 50.82 84.4033 51.12C84.6833 51.41 85.0183 51.635 85.4083 51.795C85.7983 51.955 86.2283 52.035 86.6983 52.035ZM93.7583 54V43.41H95.4083L96.1133 45.525V54H93.7583ZM101.063 54L94.8233 46.005L95.4083 43.41L101.648 51.405L101.063 54ZM101.063 54L100.433 51.885V43.41H102.788V54H101.063ZM104.833 54V43.41H106.483L107.188 45.525V54H104.833ZM112.138 54L105.898 46.005L106.483 43.41L112.723 51.405L112.138 54ZM112.138 54L111.508 51.885V43.41H113.863V54H112.138ZM115.907 54V43.41H118.262V54H115.907ZM117.707 54V51.96H123.512V54H117.707ZM117.707 49.575V47.61H122.987V49.575H117.707ZM117.707 45.435V43.41H123.437V45.435H117.707ZM129.97 54.165C129.18 54.165 128.445 54.03 127.765 53.76C127.095 53.48 126.505 53.09 125.995 52.59C125.495 52.09 125.105 51.51 124.825 50.85C124.545 50.18 124.405 49.46 124.405 48.69C124.405 47.92 124.545 47.205 124.825 46.545C125.105 45.875 125.495 45.295 125.995 44.805C126.495 44.315 127.08 43.935 127.75 43.665C128.43 43.385 129.165 43.245 129.955 43.245C130.795 43.245 131.54 43.38 132.19 43.65C132.85 43.92 133.425 44.29 133.915 44.76L132.34 46.35C132.06 46.05 131.72 45.815 131.32 45.645C130.93 45.475 130.475 45.39 129.955 45.39C129.495 45.39 129.07 45.47 128.68 45.63C128.3 45.78 127.97 46 127.69 46.29C127.42 46.58 127.205 46.93 127.045 47.34C126.895 47.75 126.82 48.2 126.82 48.69C126.82 49.19 126.895 49.645 127.045 50.055C127.205 50.465 127.42 50.815 127.69 51.105C127.97 51.395 128.3 51.62 128.68 51.78C129.07 51.94 129.495 52.02 129.955 52.02C130.495 52.02 130.965 51.935 131.365 51.765C131.765 51.595 132.11 51.36 132.4 51.06L133.99 52.65C133.48 53.12 132.895 53.49 132.235 53.76C131.585 54.03 130.83 54.165 129.97 54.165ZM137.706 54V43.56H140.061V54H137.706ZM134.391 45.465V43.41H143.376V45.465H134.391ZM149.953 54L146.548 43.41H148.888L151.378 51.555H150.463L152.893 43.41H154.738L157.168 51.555H156.268L158.743 43.41H161.068L157.663 54H155.818L153.373 45.855H154.243L151.798 54H149.953ZM160.375 54L164.575 43.41H166.705L170.86 54H168.37L165.19 45.21H166.045L162.82 54H160.375ZM162.76 52.08V50.16H168.535V52.08H162.76ZM171.981 54V43.41H174.336V54H171.981ZM173.796 54V51.93H179.031V54H173.796ZM180.389 54V43.41H182.744V54H180.389ZM182.204 54V51.93H187.439V54H182.204ZM188.797 54V43.41H191.152V54H188.797ZM190.597 54V51.96H196.402V54H190.597ZM190.597 49.575V47.61H195.877V49.575H190.597ZM190.597 45.435V43.41H196.327V45.435H190.597ZM200.299 54V43.56H202.654V54H200.299ZM196.984 45.465V43.41H205.969V45.465H196.984Z"
                        fill="white"
                      />
                      <defs>
                        <filter
                          id="filter0_d_0_1"
                          x="0"
                          y="0"
                          width="277"
                          height="108"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="6" />
                          <feGaussianBlur stdDeviation="11" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0241667 0 0 0 0 0.133016 0 0 0 0 0.2 0 0 0 0.22 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_0_1"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_0_1"
                            result="shape"
                          />
                        </filter>
                        <linearGradient
                          id="paint0_linear_0_1"
                          x1="255"
                          y1="46"
                          x2="22.0063"
                          y2="44.1862"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#825FF6" />
                          <stop offset="0.484375" stop-color="#040C15" />
                          <stop offset="1" stop-color="#8B5EF3" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
              </header>
              <div className="flex w-[33%] md:w-full mt-[151px] ml-[26px]">
                <div
                  style={{
                    color: '#F6F6F6',
                    fontSize: '110px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: '120px', // 100%
                    width: '594px',
                    height: '260px',
                    flexShrink: '0',
                  }}
                >
                  DEGEN'S RESTAKING
                </div>
              </div>
              <Text className="ml-[31px]">
                <div
                  style={{
                    color: '#F6F6F6',
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '36px',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    lineHeight: 'normal',
                    opacity:0.7,
                  }}
                >
                  Merlin&#39;s Seal Staking Supercharged
                </div>
              </Text>
              <svg
                width="277"
                height="108"
                viewBox="0 0 277 108"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_0_1)">
                  <path
                    d="M22.5 48C22.5 30.603 36.603 16.5 54 16.5H223C240.397 16.5 254.5 30.603 254.5 48C254.5 65.397 240.397 79.5 223 79.5H54C36.603 79.5 22.5 65.397 22.5 48Z"
                    stroke="url(#paint0_linear_0_1)"
                    shape-rendering="crispEdges"
                  />
                </g>
                <path
                  d="M92.6743 54V43.41H95.0293V54H92.6743ZM94.4893 54V51.93H99.7243V54H94.4893ZM99.9945 54L104.195 43.41H106.325L110.48 54H107.99L104.81 45.21H105.665L102.44 54H99.9945ZM102.38 52.08V50.16H108.155V52.08H102.38ZM115.743 54.165C114.873 54.165 114.103 53.98 113.433 53.61C112.773 53.24 112.253 52.73 111.873 52.08C111.503 51.42 111.318 50.67 111.318 49.83V43.41H113.688V49.965C113.688 50.385 113.778 50.75 113.958 51.06C114.138 51.37 114.383 51.61 114.693 51.78C115.013 51.94 115.363 52.02 115.743 52.02C116.143 52.02 116.493 51.94 116.793 51.78C117.093 51.61 117.328 51.375 117.498 51.075C117.678 50.765 117.768 50.4 117.768 49.98V43.41H120.138V49.845C120.138 50.685 119.953 51.43 119.583 52.08C119.213 52.73 118.698 53.24 118.038 53.61C117.378 53.98 116.613 54.165 115.743 54.165ZM122.015 54V43.41H123.665L124.37 45.525V54H122.015ZM129.32 54L123.08 46.005L123.665 43.41L129.905 51.405L129.32 54ZM129.32 54L128.69 51.885V43.41H131.045V54H129.32ZM138.114 54.165C137.324 54.165 136.589 54.03 135.909 53.76C135.239 53.48 134.649 53.09 134.139 52.59C133.639 52.09 133.249 51.51 132.969 50.85C132.689 50.18 132.549 49.46 132.549 48.69C132.549 47.92 132.689 47.205 132.969 46.545C133.249 45.875 133.639 45.295 134.139 44.805C134.639 44.315 135.224 43.935 135.894 43.665C136.574 43.385 137.309 43.245 138.099 43.245C138.939 43.245 139.684 43.38 140.334 43.65C140.994 43.92 141.569 44.29 142.059 44.76L140.484 46.35C140.204 46.05 139.864 45.815 139.464 45.645C139.074 45.475 138.619 45.39 138.099 45.39C137.639 45.39 137.214 45.47 136.824 45.63C136.444 45.78 136.114 46 135.834 46.29C135.564 46.58 135.349 46.93 135.189 47.34C135.039 47.75 134.964 48.2 134.964 48.69C134.964 49.19 135.039 49.645 135.189 50.055C135.349 50.465 135.564 50.815 135.834 51.105C136.114 51.395 136.444 51.62 136.824 51.78C137.214 51.94 137.639 52.02 138.099 52.02C138.639 52.02 139.109 51.935 139.509 51.765C139.909 51.595 140.254 51.36 140.544 51.06L142.134 52.65C141.624 53.12 141.039 53.49 140.379 53.76C139.729 54.03 138.974 54.165 138.114 54.165ZM143.431 54V43.41H145.786V54H143.431ZM149.986 54V43.41H152.356V54H149.986ZM144.841 49.575V47.535H150.766V49.575H144.841ZM156.025 54L160.225 43.41H162.355L166.51 54H164.02L160.84 45.21H161.695L158.47 54H156.025ZM158.41 52.08V50.16H164.185V52.08H158.41ZM169.43 50.145V48.315H171.71C172 48.315 172.265 48.255 172.505 48.135C172.745 48.015 172.935 47.84 173.075 47.61C173.215 47.38 173.285 47.1 173.285 46.77C173.285 46.45 173.215 46.175 173.075 45.945C172.935 45.715 172.745 45.54 172.505 45.42C172.265 45.3 172 45.24 171.71 45.24H169.43V43.41H172.055C172.725 43.41 173.33 43.545 173.87 43.815C174.41 44.085 174.835 44.475 175.145 44.985C175.465 45.485 175.625 46.08 175.625 46.77C175.625 47.46 175.465 48.06 175.145 48.57C174.835 49.07 174.41 49.46 173.87 49.74C173.33 50.01 172.725 50.145 172.055 50.145H169.43ZM167.63 54V43.41H169.985V54H167.63ZM178.747 50.145V48.315H181.027C181.317 48.315 181.582 48.255 181.822 48.135C182.062 48.015 182.252 47.84 182.392 47.61C182.532 47.38 182.602 47.1 182.602 46.77C182.602 46.45 182.532 46.175 182.392 45.945C182.252 45.715 182.062 45.54 181.822 45.42C181.582 45.3 181.317 45.24 181.027 45.24H178.747V43.41H181.372C182.042 43.41 182.647 43.545 183.187 43.815C183.727 44.085 184.152 44.475 184.462 44.985C184.782 45.485 184.942 46.08 184.942 46.77C184.942 47.46 184.782 48.06 184.462 48.57C184.152 49.07 183.727 49.46 183.187 49.74C182.647 50.01 182.042 50.145 181.372 50.145H178.747ZM176.947 54V43.41H179.302V54H176.947Z"
                  fill="white"
                />
                <defs>
                  <filter
                    id="filter0_d_0_1"
                    x="0"
                    y="0"
                    width="277"
                    height="108"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="6" />
                    <feGaussianBlur stdDeviation="11" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.0241667 0 0 0 0 0.133016 0 0 0 0 0.2 0 0 0 0.22 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_0_1"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_0_1"
                      result="shape"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_0_1"
                    x1="255"
                    y1="46"
                    x2="22.0063"
                    y2="44.1862"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#825FF6" />
                    <stop offset="0.484375" stop-color="#040C15" />
                    <stop offset="1" stop-color="#8B5EF3" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full h-full">
        <div className="w-screen min-h-screen bg-black-900_03 flex flex-col">
          <div className="flex-1 flex flex-col justify-around">
            <div className="flex items-center justify-center">
              <div className="relative mr-[140px]">
                <Img
                  src="/images/hero-ball-4%205.svg"
                  className="w-[530px] h-[530px] rotate-135"
                />

                <Img
                  src="/images/union.svg"
                  className="w-[90px] h-[90px] absolute left-[80px] top-[80px] z-10"
                />

                <Img
                  src="/images/img_vector.svg"
                  className="w-[209px] h-[171px] absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]"
                />
              </div>

              <div className="">
                <div className="flex items-center mb-[35px]">
                  <div className="w-[10px] h-[10px] rounded-[5px] bg-deep_purple-A200" />
                  <div className="text-white-A700 font-bold text-[14px] mx-[5px]">
                    Who we are{' '}
                  </div>
                  <div className="w-[10px] h-[10px] rounded-[5px] bg-deep_purple-A200" />
                </div>

                <div className="text-[42px] h-[160px]">
                  <div className="flex items-center">
                    <div className="text-white-A700">Merlin’s</div>
                    <div className="text-deep_purple-A200">1st</div>
                  </div>
                  <div className="flex items-center">
                    <div className="text-deep_purple-A200">Restaking</div>
                    <div className="text-white-A700">Platform</div>
                  </div>
                </div>

                <div className="w-[350px] text-gray-100_c3 text-[16px] mb-[30px]">
                  RoundTable DAO is a restaking product that can help Merlin
                  Chain users achieve higher returns.
                </div>

                <div className="w-[233px] h-[64px] rounded-[32px] border-deep_purple-A200 border-[1px] border-solid flex items-center justify-center text-[15px] font-bold text-white-A700">
                  Visit docs
                </div>
              </div>
            </div>

            <div className="flex justify-center items-center flex-col">
              <div className="flex items-center mb-[35px]">
                <div className="w-[10px] h-[10px] rounded-[5px] bg-deep_purple-A200" />
                <div className="text-white-A700 font-bold text-[14px] mx-[5px]">
                  core features
                </div>
                <div className="w-[10px] h-[10px] rounded-[5px] bg-deep_purple-A200" />
              </div>

              <div className="flex items-center text-[42px]">
                <div className="mr-[4px] text-white-A700">Why choose</div>
                <div className="text-deep_purple-A200">Merlin Chain?</div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center pb-[90px] mb-[30px]">
            <div className="w-[244px] h-[256px]">
              <div className="rounded-[60px] border-4 border-solid border-white-A700_0F bg-white-A700_12 flex items-center justify-center w-[80px] h-[80px]">
                <Img
                  src="/images/001-credit-card.svg"
                  className="w-[40px] h-[40px]"
                />
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[22px] line-height-[1.25]">
                Low Fees, High Scalability
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[15px] line-height-[1.5]">
                Ensuring swift transaction processing and enhancing transaction
                liquidity.
              </div>
            </div>

            <div className="w-[244px] h-[256px]">
              <div className="rounded-[60px] border-4 border-solid border-white-A700_0F bg-white-A700_12 flex items-center justify-center w-[80px] h-[80px]">
                <Img
                  src="/images/002-Bitcoin.svg"
                  className="w-[40px] h-[40px]"
                />
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[22px] line-height-[1.25]">
                BTC Protocols Support{' '}
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[15px] line-height-[1.5]">
                Protocols such as BRC20, BRC420, Bitmap, Atomicals, Pipe, Stamp,
                and more
              </div>
            </div>

            <div className="w-[244px] h-[256px]">
              <div className="rounded-[60px] border-4 border-solid border-white-A700_0F bg-white-A700_12 flex items-center justify-center w-[80px] h-[80px]">
                <Img src="/images/003-cvv.svg" className="w-[40px] h-[40px]" />
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[22px] line-height-[1.25]">
                ZK Rollup on Bitcoin{' '}
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[15px] line-height-[1.5]">
                to enhance efficiency, scalability, transparency and security.
              </div>
            </div>

            <div className="w-[244px] h-[256px]">
              <div className="rounded-[60px] border-4 border-solid border-white-A700_0F bg-white-A700_12 flex items-center justify-center w-[80px] h-[80px]">
                <Img src="/images/004-lock.svg" className="w-[40px] h-[40px]" />
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[22px] line-height-[1.25]">
                Native Innovation
              </div>

              <div className="mt-[30px] w-[200px] text-white-A700 text-[15px] line-height-[1.5]">
                Dedicated to delivering unique solutions designed for the
                Bitcoin network and its users.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full h-full">
        <div className="w-[100vw] min-h-screen">
          <div className="h-[70vh] bg-black-900_03 flex items-center justify-center">
            <div className="relative w-[660px] h-[660px] flex items-end justify-center">
              <Img
                src="/images/ellipse.svg"
                className="w-[660px] h-[660px] absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]"
              />
              <Img
                src="/images/new_position.svg"
                className="w-[374px] h-[495px] relative z-1"
              />
              <Img
                src="/images/rtDAO.svg"
                className="w-[354px] h-[475px] absolute left-[50%] bottom-0 translate-x-[-50%] z-2 rounded-t-[20px]"
              />
            </div>

            <div>
              <div>
                <div className="mb-[40px] text-[32px] font-bold">
                  <div className="text-white-A700 mb-10">Advantages of</div>
                  <div className="text-deep_purple-A200"> Round Table DAO</div>
                </div>
              </div>

              <div className="text-white-A700 text-[18px]">
                <div className="mb-20px">Accrue rewards for holding rtLP</div>
                <div className="mb-20px">
                  Automatic Daily Compound Interest{' '}
                </div>
                <div>Point rewards from Merlin </div>
              </div>

              <div
                className="w-[233px] h-[64px] rounded-[32px] border-deep_purple-A200 border-[1px] border-solid flex items-center justify-center text-[15px] font-bold text-white-A700 mt-[40px] cursor-pointer"
                onClick={() => alert('comming soon！')}
              >
                LAUNCH APP
              </div>
            </div>
          </div>

          <div className="h-[30vh] bg-deep_purple-A200_33 flex flex-col items-center">
            <div className="flex items-center justify-center flex-1">
              <Img
                src="/images/img_vector.svg"
                className="w-[140px] h-[155px] mr-[35px]"
              />
              <div className="w-[360px] text-[27px] text-gray-100_c3 mr-[80px]">
                restaking product that can help Merlin Chain users achieve
                higher returns
              </div>

              <div>
                <div className="text-white-A700 mb-[30px]">Useful Links</div>
                <div className="text-gray-100_c3">
                  <a
                    href="https://roundtable-dao.gitbook.io/roundtable-dao/contract/merlin-chain"
                    className="mb-[15px] block"
                  >
                    Contact us
                  </a>
                  {/*   <div className="mb-[15px]">Staking</div>*/}
                  <a
                    href="https://roundtable-dao.gitbook.io/roundtable-dao/roundtable-dao-restaking-products/how-roundtable-dao-restaking-works"
                    className="block mb-[15px]"
                  >
                    How it works
                  </a>
                </div>
              </div>

              <a href="https://twitter.com/Round_TableDAO/">
              <div className="rounded-[50%] w-[144px] h-[144px] border-solid border-[1px] border-deep_purple-A200_d6 flex items-center justify-center ml-[200px]">
                <Img
                  src="/images/X_logo.svg"
                  className="w-[68px] h-[68px]"
                ></Img>
              </div>
              </a>
            </div>

            <div className="w-[70vw] border-t-[1px] border-solid border-deep_purple-A200_33 text-white-A700 py-[30px]">
              © Copyright 2024 The Round Table DAO. All Rights Reserved
              Copyright
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
